import React from 'react';

const Alert = ({ text = "warning" }) => {
    return (
        <div className='alert'>{ text }</div>
    );
};

export default Alert;